import { render, staticRenderFns } from "./FurnitureLightingFrame.vue?vue&type=template&id=4b5ace58&"
import script from "./FurnitureLightingFrame.vue?vue&type=script&lang=js&"
export * from "./FurnitureLightingFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ageo\\Documents\\Work\\fhapplication\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5ace58')) {
      api.createRecord('4b5ace58', component.options)
    } else {
      api.reload('4b5ace58', component.options)
    }
    module.hot.accept("./FurnitureLightingFrame.vue?vue&type=template&id=4b5ace58&", function () {
      api.rerender('4b5ace58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/furniture_lighting/components/FurnitureLightingFrame.vue"
export default component.exports